/**
 * Threats — plotted danger areas, shared across the deployment.
 *
 * The same shared-list contract as zones: a threat one operator plots is one
 * the whole team plans standoff from, so it lives on the server and everyone
 * reads it. Bulk replace, because the client holds the whole list and a partial
 * update lets a stale client resurrect a threat someone else cleared.
 */

import { api, type ApiResult } from '@/api/client';

export type ThreatKind =
  | 'air-defense'
  | 'manpads'
  | 'small-arms'
  | 'jammer'
  | 'hostile'
  | 'unknown';

export interface Threat {
  threatId: string;
  name: string;
  kind: ThreatKind;
  lat: number;
  lon: number;
  lethalRadiusM: number;
  warningRadiusM: number;
}

export function listThreats(): Promise<ApiResult<{ threats: Threat[] }>> {
  return api.get<{ threats: Threat[] }>('/threats', { logged: false });
}

export function saveThreats(threats: Threat[]): Promise<ApiResult<{ threats: Threat[] }>> {
  return api.put<{ threats: Threat[] }>('/threats', { threats }, { label: 'THREATS SAVE' });
}
